// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-daterange-picker[data-v-52c60322]{width:100%}.daterangepicker[data-v-52c60322]{max-width:100%!important;width:100%!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
